import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { RoomAvailabilityBox } from './RoomAvailabilityBox';
import moment from 'moment';

export class RoomAvailabilityBar extends Component {

    renderCategory = (isTextCenter) => {
        return  <div>
            {this.props.blockId == 0 ?
                <Row>
                    <Col className="col-12 pl-0" style={isTextCenter ? { textAlign: 'center', marginBottom: '1rem' } : {}}>
                        <div className="d-inline-block">
                            <b className="pl-2 color-host">{this.props.roomCategory.description}</b>
                        </div>
                    </Col>
                </Row>
                :
                <Row style={isTextCenter ? { textAlign: 'center', marginBottom: '1rem' } : { }}>
                    <Col className={(isTextCenter ? 'col-12' : "col-10") + " pl-0" }>
                        <b className="pl-2 color-host">{this.props.roomCategory.description}</b>
                    </Col>
                    <Col className={(isTextCenter ? 'col-12' : "col-2") + " p-0 color-host"}>
                        <FormattedMessage id="EditRate.InventoryOwn" />
                    </Col>
                </Row>
            }
        </div>
    }

    render() {
        const { roomCategory, hotelAvailability, blockId, next14Days, isHost } = this.props;

        var dayAvailability = hotelAvailability.filter((rest) => roomCategory.id === rest.roomCategoryId && rest.blockId === blockId);

        return (
            <>
                {global.isMobile &&
                    <div className="IventoryFixedChild">
                        {this.renderCategory(true)}
                    </div>            
                }
                <Row className="d-flex flex-row flex-nowrap">
                    <Col className={`col-${this.props.colSize}`} style={{ borderBottom: '1px solid #165c7d', left: '0', zIndex: '1', background: 'white', position: global.isMobile ? 'relative' : 'sticky' }}>
                        {!global.isMobile && this.renderCategory(false)}
                    </Col>
                   
                    {
                        hotelAvailability && dayAvailability && next14Days && next14Days.map((item, key) =>
                            <RoomAvailabilityBox colSize={this.props.colSize} day={item} dayAvailability={dayAvailability.filter(el => item.isSame(moment(el.hotelDate), 'date'))} key={key} blockId={blockId} isHost={isHost} />
                        )
                    }
                </Row>
            </>
        );
    }
};